import gql from 'graphql-tag'

export default gql`
query getArticle($id: Int!) {
  getArticle(id: $id) {
    id
    category_id
    author_id
    header_desktop
    header_mobile
    img_featured_desktop
    img_featured_mobile
    article_date
    type
    link
    details {
      id
      title
      slug
      excerpt
      content
      language_code
      tags
      meta_title
      meta_description
      meta_tags
      meta_og_title
      meta_og_description
      meta_og_url
      published_at
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/article/get.js